<app-top-bar [title]="'Центр допомоги'"></app-top-bar>
<div class="support-enter-container">
  <div class="chat-block">
    <div class="title-chat block-background main-text-color">
      Чати
    </div>
    <div class="body-chat block-background" (click)="navigateToChats()">
      <div class="body-chat-item-container">
        <mat-icon class="accent-color" fontSet="material-icons-outlined">sms</mat-icon>
        <div class="body-chat-item-inner">
          <div class="body-chat-item-title main-text-color">Вхідні</div>
          <div class="body-chat-item-description hint-color">Переглянути відкриті чати</div>
        </div>
      </div>
      <mat-icon class="accent-color">chevron_right</mat-icon>
    </div>
  </div>
  <div class="departments-block">
    <div class="department-title block-background main-text-color">Категорії звернень</div>
    @if (sessionStorageService.retrieve('userType') !== 'dispatcher') {
      <div  class="department-item block-background" [routerLink]="['/trip-list']">
        <div class="department-item-text main-text-color">{{ 'По замовленні' }}</div>
        <mat-icon class="accent-color">chevron_right</mat-icon>
      </div>
    }
    @for (item of (departments$ | async | filterBy: ['enabled'] : true); track $index) {
      <div class="department-item block-background" (click)="navigateToDepartment(item.uuid, item.display_name)">
        <div class="department-item-text main-text-color">{{ item.display_name }}</div>
        <mat-icon class="accent-color">chevron_right</mat-icon>
      </div>
    }
  </div>
</div>
